import styleInject from '../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z=".issues-form{max-width:664px!important}@media only screen and (max-width:767px){.issues-form{max-width:none!important}}.issues-step-form-container{margin-bottom:var(--swan-sem-space-between-sections)!important}";styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=styles.scss.js.map
